/* 布局 */
//前台
import Layout from "@views/layout";

const placertificatetemplateRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "placertificatetemplate/list",
        name: "PLACERTIFICATETEMPLATE",
        meta: {
            title: "证书模板表",
        },
        component: () => import("@views/business/placertificatetemplate/index.vue"),
    },
        ],
};

export default placertificatetemplateRouter;
